import type { InvoiceDetail as InvoiceFragment } from "@/types/invoice";
import type { LineItemDetail } from "@/types/line-item";
import { getInvoiceLineItems } from "@/lib/line-items/helpers";
import { VoucherDiscountTypeEnum } from "@/__generated__/graphql";

export type InvoiceDetailData = Omit<
  InvoiceFragment,
  "dueDate" | "issueDate" | "fromDate" | "toDate" | "lineItems"
> & {
  balance: number;
  dueDate: Date;
  issueDate: Date;
  fromDate: Date;
  toDate: Date;
  lineItems: LineItemDetail[];
  qrCodeUrl: string;
  discountAmount: number;
};

export function getInvoiceDetailData(
  invoice: InvoiceFragment,
): InvoiceDetailData {
  let discountValue = 0;

  if (invoice.appliedVoucher) {
    if (
      invoice.appliedVoucher.discountType === VoucherDiscountTypeEnum.Percentage
    ) {
      discountValue =
        (invoice.lineItemsTotal * invoice.appliedVoucher.discountValue) / 100;
    } else {
      discountValue = invoice.appliedVoucher.discountValue;
    }
  }

  return {
    id: invoice.id,
    amount: invoice.amount,
    balance: invoice.totalAmount - invoice.paidAmount,
    paidAmount: invoice.paidAmount,
    baseAmount: invoice.baseAmount,
    paymentStatus: invoice.paymentStatus,
    fromDate: new Date(invoice.fromDate),
    toDate: new Date(invoice.toDate ?? 0),
    issueDate: new Date(invoice.issueDate ?? 0),
    dueDate: new Date(invoice.dueDate ?? 0),
    status: invoice.status,
    pdfUrl: invoice.pdfUrl,
    totalAmount: invoice.totalAmount,
    pdfReceiptUrl: invoice.pdfReceiptUrl,
    appliedVoucher: invoice.appliedVoucher ?? null,
    lineItems: invoice.lineItems?.map(getInvoiceLineItems) ?? [],
    qrCodeUrl: invoice.qrCodeUrl ?? "",
    lineItemsTotal: invoice.lineItemsTotal,
    discountAmount: discountValue,
  };
}
